import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import NumberUtils from "util/NumberUtils";
import { Markdown, IconButton } from "components/common";
import zIndices from "theme/z-indices";
import PreviewModal from "./PreviewModal";
const Container = styled.div`
  position: relative;
  padding: 8px 0;
  background-color: ${({ theme, $noBackground }) => $noBackground ? "transparent" : theme.colors.global.contentBackground};
  ${({ $noBorder }) => !$noBorder && css`
      border: 1px solid ${({ theme }) => theme.colors.input.border};
    `}
  border-radius: 4px;
  flex-grow: 1;
  overflow: hidden auto;

  height: ${({ $height, $maxHeight }) => (
  // eslint-disable-next-line no-nested-ternary
  $height && !$maxHeight ? NumberUtils.isNumber($height) ? `${$height}px` : $height : "auto"
)};
  min-height: 50px;
  width: 100%;
  max-height: ${({ $maxHeight }) => (
  // eslint-disable-next-line no-nested-ternary
  $maxHeight ? NumberUtils.isNumber($maxHeight) ? `${$maxHeight}px` : $maxHeight : "auto"
)};
`;
const ExpandIconButton = styled(IconButton)`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 8px 16px;
  cursor: pointer;
  z-index: ${zIndices.expandButton};
`;
const MarkdownStyles = styled.div`
  overflow: hidden auto;
  height: 100%;
  padding: ${({ $noPadding }) => $noPadding ? "4px 0" : "0 8px"};

  container-type: inline-size;

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    margin-bottom: 8px;
    font-family: ${({ theme }) => theme.fonts.family.body};
  }

  & > hr {
    margin: 16px 0;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.brand.tertiary};
  }

  & ul,
  & ol {
    padding-left: 1.5rem;
    margin: 8px 0;

    & > li {
      padding: 4px 0;
    }
  }

  & ul {
    list-style-type: disc;
  }

  & p {
    white-space: pre-line;
    margin: 8px 0;
  }

  & table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 8px 0;

    & th,
    & td {
      border: 1px solid ${({ theme }) => theme.colors.input.border};
      padding: 4px 8px;
    }
  }
`;
function Preview({
  value,
  height = void 0,
  maxHeight = void 0,
  show,
  withFullView = false,
  noBackground = false,
  noBorder = false,
  noPadding = false
}) {
  const [fullView, setFullView] = useState(false);
  return show && /* @__PURE__ */ React.createElement(Container, { $height: height, $maxHeight: maxHeight, $noBackground: noBackground, $noBorder: noBorder }, /* @__PURE__ */ React.createElement(MarkdownStyles, { $noPadding: noPadding }, /* @__PURE__ */ React.createElement(Markdown, { text: value, augment: true })), withFullView && /* @__PURE__ */ React.createElement(ExpandIconButton, { name: "expand_content", title: "Expand content", size: "sm", onClick: () => setFullView(true) }), /* @__PURE__ */ React.createElement(PreviewModal, { value, show: fullView, onClose: () => setFullView(false) }));
}
export default Preview;
